module.exports = __webpack_public_path__ + "static/media/reporting_empty_uploadflyer.2a18e301.svg";